import React, { useRef } from 'react';
import clsx from 'clsx';
import { Icon } from '../../icon';
import { Card } from '../../card';
import ModalContext from '../context/context';
import { useTrapTab, setRef } from '../../../../hooks';
import * as styles from '../modal.styles';

/**
 * @type {typeof import('../../card').Card}
 */
const ModalCard = React.forwardRef(({ children, className, ...props }, ref) => {
  const { onClose, hideClose } = React.useContext(ModalContext);
  const innerRef = useRef();
  useTrapTab({ ref: innerRef, enabled: true });

  return (
    <Card className={clsx(className)} {...props} ref={setRef(innerRef, ref)}>
      {!hideClose && (
        <Icon
          withEnterAsClick
          isInteractive
          name="cross"
          className={styles.components.close}
          role="button"
          onClick={onClose}
          tabIndex={0}
          data-modal-role="close-button"
        />
      )}
      {children}
    </Card>
  );
});

ModalCard.propTypes = Card.propTypes;

if (process.env.NODE_ENV !== 'production') {
  ModalCard.displayName = 'Modal.Card';
}

export default ModalCard;
